import * as React from "react";
import {connect, Dispatch} from "react-redux";
import {OnFailure, OnSuccess} from "../../../store/action/actionHelpers";
import {RootState} from "../../../store/reducer/root/RootState";
import {fetchUtilities, createUtility, updateUtility, deleteUtility} from "../../../store/action/utility/utility";
import Utility from "../../../model/utility/Utility";
import {none, option, Option} from "ts-option";
import PageHeaderView from "../../body/PageHeaderView";
import PageContentView from "../../body/PageContentView";
import Loading from "../../ui/loading/Loading";
import UtilitiesTable from "./UtilitiesTable";
import EditUtilityModal from "./modal/EditUtilityModal";
import CreateUtilityModal from "./modal/CreateUtilityModal";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";
import ButtonGroupWrapper from "../../../hiberUiKit/src/atoms/Buttons/ButtonGroupWrapper";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";

interface ReduxProps {
	utilities: Utility[];
}

interface DispatchProps {
	fetchUtilities: (onSuccess: OnSuccess, onFailure: OnFailure) => void;
	createUtility: (utility: Utility, onSuccess: OnSuccess, onFailure: OnFailure) => void;
	updateUtility: (utilityId: string, utility: Utility, onSuccess: OnSuccess, onFailure: OnFailure) => void;
	deleteUtility: (utilityId: string, onSuccess: OnSuccess, onFailure: OnFailure) => void;
}

type Props = ReduxProps & DispatchProps;

interface IComponentState {
	editedUtility: Option<Utility>;
	showCreateModal: boolean;
	isFetched: boolean;
}

class UtilitiesList extends React.Component<Props, IComponentState> {

	constructor(props: Props) {
		super(props);
		this.state = {
			editedUtility: none,
			showCreateModal: false,
			isFetched: false
		};
		this.props.fetchUtilities(() => {
			this.setState({
				isFetched: true
			})
		}, (err) => {
			notifyBugsnagAndShowToast(err, "Fetch utilities");
			this.setState({
				isFetched: true
			})
		});
	}

	render() {
		return (
			<React.Fragment>
				<PageHeaderView header={"Utilities"}>
					<ButtonGroupWrapper>
						<ButtonPrimary onClick={() => {this.setState({showCreateModal: true})}}
									   label={"Create Utility"}
									   variant={"burgundy"}/>
					</ButtonGroupWrapper>
				</PageHeaderView>
				<PageContentView>
					<Loading isLoading={this.state.isFetched === false}>
						<UtilitiesTable
							utilities={this.props.utilities}
							onRowClick={(item) => this.setState({editedUtility: option(item)})}
							onDelete={(utilityId) => this.props.deleteUtility(utilityId,
								() => {}, (err) => notifyBugsnagAndShowToast(err, "Delete utility"))} />
					</Loading>
					{this.renderEditModal()}
					{this.renderCreateModal()}
				</PageContentView>
			</React.Fragment>
		);
	}

	renderEditModal() {
		if (this.state.editedUtility.isDefined) {
			return (
				<EditUtilityModal
					editedUtility={this.state.editedUtility.get}
					onClose={() => this.setState({editedUtility: none})} />
			);
		}
	}

	renderCreateModal() {
		if (this.state.showCreateModal) {
			return (
				<CreateUtilityModal
					onClose={() => this.setState({showCreateModal: false})}
					onCreate={(utility) => this.props.createUtility(utility,
						() => this.setState({showCreateModal: false}),
						(err) => notifyBugsnagAndShowToast(err, "Create utility"))} />
			);
		}
	}
}

function mapStateToProps(state: RootState) {
	return {
		utilities: [].concat(state.utility.utilities.getOrElse([]))
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		fetchUtilities: (onSuccess: OnSuccess, onFailure: OnFailure) =>
			dispatch(fetchUtilities(() => onSuccess(), onFailure)),
		createUtility: (utility: Utility, onSuccess: OnSuccess, onFailure: OnFailure) =>
			dispatch(createUtility(utility, () => onSuccess(), onFailure)),
		updateUtility: (utilityId: string, utility: Utility, onSuccess: OnSuccess, onFailure: OnFailure) =>
			dispatch(updateUtility(utilityId, utility, () => onSuccess(), onFailure)),
		deleteUtility: (utilityId: string, onSuccess: OnSuccess, onFailure: OnFailure) =>
			dispatch(deleteUtility(utilityId, () => onSuccess(), onFailure))
	}
}

export default connect<ReduxProps, DispatchProps, null>(mapStateToProps, mapDispatchToProps)(UtilitiesList)
